import { PocDivider } from 'commons/components/components-wrapper/poc-divider.component';
import { useTranslation } from 'core/i18n/i18n';
import { CustomNotificationFormLayout } from 'modules/settings/components/custom-notifications/custom-notification-form-layout';
import { CustomNotificationFormSubmitButton } from 'modules/settings/components/custom-notifications/custom-notification-form-submit-button';
import { CustomNotificationOptionalSettingsSection } from 'modules/settings/components/custom-notifications/custom-notification-optional-settings-section';
import { OperatorCustomNotificationFormFields } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/components/operator-custom-notification-form-fields/operator-custom-notification-form-fields.component';
import { CustomNotificationThresholdsSection } from 'modules/settings/components/custom-notifications/custom-notification-thresholds-section';
import { useOperatorCustomNotificationForm } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/hooks/use-operator-custom-notification-form.hook';
import {
    OPERATOR_CUSTOM_NOTIFICATION_FORM_HEADER_KEYS,
    OPERATOR_CUSTOM_NOTIFICATION_FORM_OPTIONAL_SETTINGS_KEYS,
    OPERATOR_CUSTOM_NOTIFICATION_FORM_SUBMIT_KEYS,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/settings-operator-custom-notification-form.constants';

export const SettingsOperatorCustomNotificationFormContainer: React.FC = () => {
    const { t } = useTranslation();
    const {
        mode,
        form,
        thresholdsTouched,
        isLoadingNotification,
        deviceTypeOptions,
        triggerOptions,
        isLoadingDeviceTypes,
        isLoadingCatalogue,
        canSubmit,
        isSubmitting,
        nameCustomValidationCode,
        fieldValidity,
        windowDaysValidity,
        validationMessages,
        setName,
        handleSubmit,
        setField,
        setDraftIds,
        applySelection,
        setThresholdField,
        setResettable,
        handleClose,
    } = useOperatorCustomNotificationForm();

    return (
        <CustomNotificationFormLayout
            loading={isLoadingNotification}
            headerTitle={t(OPERATOR_CUSTOM_NOTIFICATION_FORM_HEADER_KEYS[mode])}
            onClose={handleClose}
            footer={[
                <CustomNotificationFormSubmitButton
                    key="operator-custom-notification-submit"
                    labelKey={OPERATOR_CUSTOM_NOTIFICATION_FORM_SUBMIT_KEYS[mode]}
                    disabled={!canSubmit}
                    isSubmitting={isSubmitting}
                    onClick={handleSubmit}
                />,
            ]}
        >
            <OperatorCustomNotificationFormFields
                name={form.name}
                deviceTypes={form.deviceTypes}
                triggers={form.triggers}
                windowDays={form.windowDays}
                deviceTypeOptions={deviceTypeOptions}
                triggerOptions={triggerOptions}
                isLoadingDeviceTypes={isLoadingDeviceTypes}
                isLoadingTriggers={isLoadingCatalogue}
                validationMessages={validationMessages}
                nameValidity={fieldValidity.name}
                nameCustomValidationCode={nameCustomValidationCode}
                triggersValidity={fieldValidity.triggers}
                windowDaysValidity={windowDaysValidity}
                onNameChange={setName}
                onDeviceTypesDraftChange={(value) => setDraftIds('deviceTypes', value)}
                onDeviceTypesApply={(value) => applySelection('deviceTypes', value)}
                onTriggersDraftChange={(value) => setDraftIds('triggers', value)}
                onTriggersApply={(value) => applySelection('triggers', value)}
                onWindowDaysChange={(value) => setField('windowDays', value)}
            />

            <PocDivider />

            <CustomNotificationThresholdsSection
                notifications={form.notifications}
                thresholdsTouched={thresholdsTouched}
                onEnabledChange={(level, enabled) => setThresholdField(level, 'enabled', enabled)}
                onNumberOfEventsChange={(level, numberOfEvents) =>
                    setThresholdField(level, 'numberOfEvents', numberOfEvents)
                }
            />

            <PocDivider />

            <CustomNotificationOptionalSettingsSection
                isResettable={form.isResettable}
                requiresCommentOnReset={form.requiresCommentOnReset}
                translationKeys={OPERATOR_CUSTOM_NOTIFICATION_FORM_OPTIONAL_SETTINGS_KEYS}
                onResettableChange={setResettable}
                onRequiresCommentOnResetChange={(value) => setField('requiresCommentOnReset', value)}
            />
        </CustomNotificationFormLayout>
    );
};
